import { z } from "zod";

export const EventOutsourceInstallmentStatusSchema = z.enum([
  "pending",
  "in_payout",
  "paid",
  "cancelled",
]);
export type EventOutsourceInstallmentStatus = z.infer<
  typeof EventOutsourceInstallmentStatusSchema
>;

export const EventOutsourcePaymentModeSchema = z.enum([
  "lump_sum",
  "installments",
]);
export type EventOutsourcePaymentMode = z.infer<
  typeof EventOutsourcePaymentModeSchema
>;

export const EventOutsourceInstallmentSchema = z.object({
  id: z.string(),
  eventOutsourceId: z.string(),
  installmentNo: z.number().int(),
  label: z.string().nullable(),
  labelEn: z.string().nullable(),
  dueDate: z.coerce.date().nullable(),
  amount: z.number().int().positive(),
  status: EventOutsourceInstallmentStatusSchema,
  linkedPayoutId: z.string().nullable(),
  sortOrder: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type EventOutsourceInstallmentDTO = z.infer<
  typeof EventOutsourceInstallmentSchema
>;

export const EventOutsourceInstallmentPlanRowInputSchema = z.object({
  installmentNo: z.number().int().positive(),
  label: z.string().max(200).nullable().optional(),
  labelEn: z.string().max(200).nullable().optional(),
  dueDate: z.string().nullable().optional(),
  amount: z.number().int().positive(),
});

export const SaveEventOutsourceInstallmentPlanSchema = z.object({
  paymentMode: EventOutsourcePaymentModeSchema,
  rows: z.array(EventOutsourceInstallmentPlanRowInputSchema).optional(),
  templateId: z.string().min(1).optional(),
  planAnchorDate: z.string().optional(),
});
export type SaveEventOutsourceInstallmentPlanDTO = z.infer<
  typeof SaveEventOutsourceInstallmentPlanSchema
>;

export const AdminRecalcEventOutsourceAgreedAmountSchema = z.object({
  agreedAmount: z.number().int().positive("ຍອດຕ້ອງຫຼາຍກວ່າ 0"),
  recalculatePendingInstallments: z.literal(true),
});
export type AdminRecalcEventOutsourceAgreedAmountDTO = z.infer<
  typeof AdminRecalcEventOutsourceAgreedAmountSchema
>;

export const CreateOutsourceInstallmentPayoutSchema = z.object({
  installmentId: z.string().min(1).optional(),
  notes: z.string().trim().optional(),
});
export type CreateOutsourceInstallmentPayoutDTO = z.infer<
  typeof CreateOutsourceInstallmentPayoutSchema
>;
